
import useCurrentUserProfile from '../../../hooks/useCurrentUserProfile';
const Header = ({ toggleSidebar }) => {
    const {profile} = useCurrentUserProfile()
  return (
    <header className="bg-white border-b border-gray-200 py-2 md:py-5 pl-2 pr-2 md:pr-6 flex items-center justify-between sticky top-0 z-40">
      {/* Sidebar toggle */}
      <button 
        className="w-10 h-10 hidden md:block  flex items-center justify-center  transition-colors"
        onClick={toggleSidebar}
      >
        <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

     <div className="flex-1 flex justify-end items-center gap-3">
  <div className="relative">
    
    {/* Profile Image OR Default Icon */}
    <div className="w-10 h-10 rounded-xl overflow-hidden bg-[#e8f0f7] flex items-center justify-center">
      {profile?.profile_picture ? (
        <img
          src={profile.profile_picture}
          alt="profile"
          className="w-full h-full object-cover"
        />
      ) : (
        <svg
          className="w-5 h-5 text-[#0f6abf]"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          />
        </svg>
      )}
    </div>
    
  </div>

  {/* User Info */}
  <div>
    <div className="flex items-center gap-2">
      <p className="text-sm font-semibold text-gray-900">
        {profile?.name || "User"}
      </p>
      <span className="px-2 py-0.5 bg-[#e8f0f7] text-[#0f6abf] text-xs font-medium rounded-lg">
        Dean
      </span>
    </div>
    <p className="text-xs text-gray-500 truncate max-w-[200px]">
      {profile?.email}
    </p>
  </div>
</div>
    </header>
  );
};

export default Header;